var map = {
	"./btn_finish.svg": "2ff9",
	"./btn_pause_default.svg": "9911",
	"./btn_play_default.svg": "f44d",
	"./btn_play_disabled.svg": "09b9",
	"./btn_stop_default.svg": "f88d",
	"./btn_waiting.svg": "5b90",
	"./eye-off.svg": "bf89",
	"./eye-on.svg": "ba52",
	"./hamburger.svg": "bd6a",
	"./icon_asr_offline.svg": "d602",
	"./icon_asr_offline2.svg": "70e7",
	"./icon_asr_rt.svg": "5da2",
	"./icon_asr_rt2.svg": "3e68",
	"./icon_mt_file.svg": "bb11",
	"./icon_mt_file2.svg": "5564",
	"./icon_mt_list.svg": "3e3d",
	"./icon_mt_txt.svg": "9d6e",
	"./icon_mt_txt2.svg": "ca03",
	"./icon_ocr_card.svg": "eacf",
	"./icon_ocr_card2.svg": "a131",
	"./icon_ocr_list.svg": "8247",
	"./icon_ocr_text.svg": "14c7",
	"./icon_ocr_text2.svg": "6863",
	"./icon_person.svg": "9b33",
	"./icon_refresh.svg": "abbd",
	"./icon_result_list.svg": "e5bf",
	"./icon_statistics.svg": "cab9",
	"./icon_task_fail.svg": "ff9f",
	"./icon_task_success.svg": "361e",
	"./icon_task_uploading.svg": "25b3",
	"./icon_task_waiting.svg": "b72f",
	"./icon_task_working.svg": "7380",
	"./icon_tts_batch.svg": "0287",
	"./icon_tts_batch2.svg": "5465",
	"./icon_tts_boy.svg": "1818",
	"./icon_tts_boy_disabled.svg": "5fe9",
	"./icon_tts_cn_chenwenwei_common.svg": "5626",
	"./icon_tts_cn_chenwenwei_common_disabled.svg": "159e",
	"./icon_tts_cn_shuhuanyu_common.svg": "e32a",
	"./icon_tts_cn_shuhuanyu_common_disabled.svg": "d4a0",
	"./icon_tts_cn_tianmeiru_common.svg": "6a7d",
	"./icon_tts_cn_tianmeiru_common_disabled.svg": "7fdb",
	"./icon_tts_cn_xiaoyaowei_common.svg": "5571",
	"./icon_tts_cn_xiaoyaowei_common_disabled.svg": "dd2d",
	"./icon_tts_cn_xinwenhan_common.svg": "2158",
	"./icon_tts_cn_xinwenhan_common_disabled.svg": "0507",
	"./icon_tts_girl.svg": "7a84",
	"./icon_tts_girl_disabled.svg": "ba68",
	"./icon_tts_record.svg": "68ef",
	"./icon_tts_rt.svg": "cdb3",
	"./icon_tts_rt2.svg": "cc1d",
	"./jt_home.svg": "4852",
	"./jt_system_settings.svg": "78b0",
	"./lock.svg": "ab00",
	"./nav_hot_word.svg": "8f5c",
	"./nav_model_edit.svg": "a17f",
	"./nav_offline_transmit.svg": "ed6b",
	"./nav_real_time.svg": "5e13",
	"./nav_record_manage.svg": "fc65",
	"./nav_text_train.svg": "166b",
	"./nav_user_manage.svg": "7f48",
	"./table.svg": "47f1",
	"./user.svg": "b3b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";